export const TYPE_PLACEHOLDER = 'Select Medicaid Type';

const MONTH_VIEWS: ['year', 'month'] = ['year', 'month'];

export const MONTH_PICKER_PROPS = {
  placeholder: 'MM/YYYY',
  views: MONTH_VIEWS,
  dateFormat: 'MM/yyyy',
};

export const TYPE_LOCKED_TOOLTIP =
  'If you want to edit the medicaid plan, please archive it first and create a new medicaid plan.';

export const EXPIRATION_DATE_ERROR_CODES = [
  'medicaid_plan_expiration_date_in_future',
  'medicaid_plan_expiration_date_before_effective_date',
];

export const EDITS_DISABLED_TOOLTIP =
  'This functionality is disabled at the clinic level by the Super Administrator.';
